import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

import MenuPopover from './MenuPopover.js'

export default function Maps(props) {
  return (
              <MenuPopover changed={props.changed} title="Map">
                <Box sx={{ margin: 4, width: 300 }}>
                <FormGroup>
                  {props.mapTypeAvailable.map((child, index) =>
                    <FormControlLabel
                      key={child['column']+index}
                      control={<Checkbox
                                  checked={props.mapTypeAvailableChecked[index]} 
                                  onChange={(e)=>props.mapTypeAvailableCheckedChange(index,e)}/>}
                      label={child['name']} />
                  )}
                  <Slider
                    getAriaLabel={() => 'Map size'}
                    value={props.mapSize}
                    onChange={(e,v)=>props.mapSizeChange(v)}
                    min={16}
                    max={2000}
                    valueLabelDisplay="auto"
                  />
                  <Typography>From area of {props.mapSize[0]} to {props.mapSize[1]}</Typography>
                </FormGroup>
                </Box>
              </MenuPopover>

  )
}

Maps.propTypes = {
  changed: PropTypes.bool,
  mapSize: PropTypes.array,
  mapSizeChange: PropTypes.func,
  mapTypeAvailableChecked: PropTypes.array,
  mapTypeAvailable: PropTypes.array,
  mapTypeAvailableCheckedChange: PropTypes.func
};
